export default {
  // 中文配置
  studio_info: '工作室信息',
  studio_name: '工作室名称',
  studio_name_lowercase: '工作室名称',
  studio_id: '工作室 ID',
  new_studio_button: '创建新工作室',
  new_studio: '新工作室',
  apply_to_join: '申请加入',
  please_choose_a: '请选择一个',
  studio: '工作室',
  apply_to_join_upper: '申请加入',
  studio_setting_delete_success: '{{studioName}} 已成功删除！',
  studio_setting_delete_failed: '删除 {{studioName}} 失败',
  studio_setting_put_name_success: '您已成功更改工作室名称。',
  studio_setting_put_name_failed: '编辑工作室名称失败！',
  delete_studio: '删除工作室',
  delete_studio_confirm_desc:
    '您确定要删除工作室：{{studioName}} 吗？这将永久删除该组织及所有相关数据。',
  delete_studio_failed_desc:
    '此工作室下仍有游戏存在。请在继续此操作前删除与此工作室相关的所有游戏。',
  delete_studio_failed: '删除失败',
  delete_studio_permanently_tip:
    '点击“删除工作室”，以开始进行永久删除工作室和游戏。',
  join_success: '加入成功。',
  studio_application_sent_success: '您的申请已成功发送。',
  studio_invitation_already_sent: '您的申请已发送至工作室，请耐心等待24小时。',
  studio_not_exist: '此工作室不存在',
  only_join_one: '您只能加入一个工作室',
  already_joined_this_studio: '申请失败，您已经加入该工作室',
  fail_to_apply: '申请失败',
  please_enter_studio: '请输入您想申请的工作室 ID',
  please_enter_studio_id: '请输入工作室 ID',
  reason: '原因',
  please_enter_reason_desc: '请输入申请原因',
  please_enter_reason: '请输入您的申请原因',
  send: '发送',
  create_studio_success: '创建工作室成功！',
  create_studio_fail: '创建工作室失败！',
  maximum_max_lint_characters: '最多限制 {{maxLimit}} 个字符',
  please_enter_your_studio_name: '请输入您的工作室名称',
  create_now: '立即创建',
  no_studio_title: '您的门户中没有工作室和游戏。',
  no_studio_content: '您可以通过创建新工作室或向其他工作室提交申请来开始使用。',
  operate_success: '操作成功。',
  operate_fail: '操作失败。',
  user_already_joined_another_studio: '此用户已加入另一个工作室。',
  sure_approve_applicant: '您确定要通过申请人吗？',
  sure_reject_applicant: '您确定要驳回申请人吗？',
  role: '角色',
  no_pending_invitations: '没有待处理的邀请。',
  remove_success: '移除成功！',
  remove_fail: '移除失败。',
  remove_failed: '移除失败',
  can_not_remove_oneself: '不能移除自己',
  transfer_success: '转让成功！',
  transfer_fail: '转让失败。',
  transfer: '转让',
  transfer_permission: '转让权限',
  remove_member: '移除成员',
  sure_quit_organization: '您确定要退出组织吗？：',
  sure_transfer_permission: '确定将你的Owner权限转移给 : ',
  sure_transfer_permission_desc2: '而你的权限自动更改为Admin',
  transfer_owner_role_first: '您需要先将所有者角色转让给其他人。',
  invite: '邀请成员',
  invite_member: '邀请成员',
  search_name: '搜索名称',
  invite_success: '邀请已成功发送',
  invite_fail: '邀请失败。',
  please_select: '请选择！',
  format_verification_error: '格式验证错误',
  enter_wecom_name: '输入企业微信名称',
  enter_email_address: '输入电子邮件地址',
  organization: '组织管理',
  members: '团队成员',
  applications: '申请列表',
  create_new_title: '创建新游戏',
  portal: '门户',
  my_studios_portal: '我的工作室门户',
  last_update: '最后更新时间：',
  services_focus_innovation: '从InGame开始',
  services_focus_innovation_cn: '创建属于你的游戏新世界',
  // 工作室下展示的文档
  doc_in_game_services_title: 'InGame 服务',
  doc_in_game_services_content: '浏览 InGame 文档和指南',
  sample_demo_tutorials_title: '示例演示教程',
  sample_demo_tutorials_content:
    '这些教程将为您提供集成和使用 InGame 的第一手经验。',
  sdks_tools_title: 'SDKs & 工具',
  sdks_tools_content: '使用我们的 SDK 将我们的服务集成到您的游戏中。',
  knowledge_base_title: '知识库',
  knowledge_base_content:
    '在这里找到与 InGame 相关的发布说明和最佳实践的更多信息！',
  get_up_to_speed_steps_desc: '通过快速入门指南，轻松几步了解InGame平台',
  get_started_title: '开始体验腾讯游戏 InGame',
  get_started_content: 'InGame 服务让您专注于创新',
  learn_more: '了解更多',
  setting: '设置',
  setting_name: '基础信息',
  user_already_invited_or_member: '此用户已被邀请或者已是组织的成员。',
  go_to_website: '前往官网',
  only_numbers: '只允许输入数字',
};
